import { createAsyncThunk } from '@reduxjs/toolkit';

import { instance } from '../../shared/services/app/instance';
import { setToken } from '../../shared/services/app/instance';

import * as toasty from '../../shared/toastify/toastify';

const fetchAllAdminUsers = createAsyncThunk(
  'admin/fetch',
  async (_, thunkApi) => {
    const state = thunkApi.getState();
    const token = state.auth.token;

    setToken(token);

    try {
      const response = await instance.get('/all');
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error.message);
    }
  }
);

const fetchAllAdminUsersByQuery = createAsyncThunk(
  'admin/fetch/filter',
  async (q, thunkApi) => {
    const { page, limit, name, email, role, status } = q;
    const state = thunkApi.getState();
    const token = state.auth.token;

    setToken(token);

    try {
      const response = await instance.get('/all', {
        params: { page, limit, name, email, role, status },
      });
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error.message);
    }
  }
);

const fetchOneAdminUser = createAsyncThunk(
  'oneAdmin/fetch',
  async (_id, thunkApi) => {
    const state = thunkApi.getState();
    const token = state.auth.token;

    setToken(token);

    try {
      const response = await instance.get(`/id/${_id}`);
      return response.data;
    } catch (error) {
      toasty.toastError('Please try again later');
      return thunkApi.rejectWithValue(error.message);
    }
  }
);

const banAdminUser = createAsyncThunk(
  'banAdmin/fetch',
  async (_id, thunkApi) => {
    const state = thunkApi.getState();
    const token = state.auth.token;

    setToken(token);

    try {
      const response = await instance.patch(`/ban/${_id}`, {});
      toasty.toastSuccess('Status change successfully');
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error.message);
    }
  }
);

const unbanAdminUser = createAsyncThunk(
  'unbanAdmin/fetch',
  async (_id, thunkApi) => {
    const state = thunkApi.getState();
    const token = state.auth.token;

    setToken(token);

    try {
      const response = await instance.patch(`/unban/${_id}`, {});
      toasty.toastSuccess('Status change successfully');
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error.message);
    }
  }
);

const updateUserRole = createAsyncThunk(
  'updateUserRole/patch',
  async ({ id, role }, thunkApi) => {
    const state = thunkApi.getState();
    const token = state.auth.token;

    setToken(token);

    try {
      const response = await instance.patch(`/role/${id}`, { role });
      toasty.toastSuccess('Role updated successfully');
      return response.data.data;
    } catch (error) {
      toasty.toastError(error.response?.data?.message || 'Failed to update role');
      return thunkApi.rejectWithValue(error.response?.data?.message || 'Failed to update role');
    }
  }
);

const updateAdminStatus = createAsyncThunk(
  'updateAdminStatus/patch',
  async ({ id, status }, thunkApi) => {
    const state = thunkApi.getState();
    const token = state.auth.token;

    setToken(token);

    try {
      const response = await instance.patch(`/status/${id}`, { status });
      toasty.toastSuccess('Status updated successfully');
      return response.data.data;
    } catch (error) {
      toasty.toastError(error.response?.data?.message || 'Failed to update status');
      return thunkApi.rejectWithValue(error.response?.data?.message || 'Failed to update status');
    }
  }
);

const updateAdminUser = createAsyncThunk(
  'admin/update',
  async ({ id, data }, thunkApi) => {
    const state = thunkApi.getState();
    const token = state.auth.token;

    setToken(token);

    try {
      const response = await instance.patch(`/id/${id}`, data);
      toasty.toastSuccess('Admin updated successfully');
      return response.data;
    } catch (error) {
      toasty.toastError(error.response?.data?.message || 'Failed to update admin');
      return thunkApi.rejectWithValue(error.response?.data?.message || 'Failed to update admin');
    }
  }
);

const adminUsersOperations = {
  fetchAllAdminUsers,
  fetchAllAdminUsersByQuery,
  fetchOneAdminUser,
  banAdminUser,
  unbanAdminUser,
  updateUserRole,
  updateAdminStatus,
  updateAdminUser,
};

export default adminUsersOperations;
